const translations: Record<string, string> = {
  "site.name": "kaiyun com",
  "site.tagline": "正版授权 · 安全稳定 · 极速响应",
  "site.description": "kaiyun com 是您值得信赖的官方平台入口，提供安全、稳定、流畅的一站式服务体验。",

  "nav.home": "首页",
  "nav.category": "分类导航",
  "nav.articles": "最新资讯",
  "nav.about": "关于我们",
  "nav.login": "登录",
  "nav.register": "注册",

  "hero.title": "值得信赖的官方平台",
  "hero.subtitle": "kaiyun com 为您提供安全、稳定、流畅的一站式服务体验",
  "hero.cta_primary": "立即访问",
  "hero.cta_secondary": "了解更多",

  "features.title": "为什么选择 kaiyun com",
  "features.subtitle": "六大核心优势，为您保驾护航",
  "features.security.title": "正版授权",
  "features.security.desc": "官方正版授权平台，确保您的权益得到全面保障，让每一次体验都安心可靠。",
  "features.stable.title": "稳定可靠",
  "features.stable.desc": "采用先进的分布式架构，确保平台7×24小时稳定运行，告别卡顿与延迟。",
  "features.speed.title": "极速响应",
  "features.speed.desc": "毫秒级响应速度，智能网络加速技术，让您的每一步操作都流畅自如。",
  "features.service.title": "全天候客服",
  "features.service.desc": "专业客服团队24小时在线，随时为您解答疑问、处理问题，服务永不打烊。",
  "features.data.title": "数据安全",
  "features.data.desc": "银行级加密传输，多重安全防护体系，全方位守护您的隐私与数据安全。",
  "features.experience.title": "优质体验",
  "features.experience.desc": "精心打磨每一个交互细节，简洁直观的界面设计，让操作成为一种享受。",

  "categories.title": "热门分类",
  "categories.subtitle": "探索丰富多样的内容，发现属于您的精彩",
  "categories.view_all": "查看全部",

  "news.title": "最新资讯",
  "news.subtitle": "掌握行业动态，了解平台最新消息",
  "news.read_more": "阅读全文",
  "news.view_all": "查看全部资讯",

  "stats.years": "年行业深耕",
  "stats.users": "万+信赖用户",
  "stats.countries": "个国家/地区覆盖",
  "stats.uptime": "%平台可用率",

  "faq.title": "常见问题",
  "faq.subtitle": "快速解答您的疑问，助您无忧使用",

  "cta.title": "开启您的优质平台之旅",
  "cta.subtitle": "立即加入 kaiyun com，享受正版授权、极速响应与全天候客服支持",
  "cta.button": "立即访问",

  "footer.rights": "版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.disclaimer": "免责声明",
  "footer.sitemap": "网站地图",

  "about.title": "关于我们",
  "about.brand_intro": "品牌介绍",
  "about.reputation": "品牌信誉",
  "about.contact": "联系我们",
  "about.story.title": "品牌故事",
  "about.mission.title": "我们的使命",
  "about.vision.title": "我们的愿景",
  "about.values.title": "核心价值观",

  "breadcrumb.home": "首页",

  "article.back": "返回资讯列表",
  "article.related": "相关文章",
  "article.share": "分享文章",
  "article.publish_date": "发布时间",

  "category.all": "全部",
  "category.no_content": "暂无内容",

  "contact.name": "姓名",
  "contact.email": "邮箱",
  "contact.message": "留言内容",
  "contact.submit": "提交",
  "contact.success": "提交成功，我们将尽快与您联系！",
  "contact.error": "提交失败，请稍后重试。",
  "contact.placeholder_name": "请输入您的姓名",
  "contact.placeholder_email": "请输入您的邮箱地址",
  "contact.placeholder_message": "请输入您的留言内容（500字以内）",

  "schema.org_name": "kaiyun com",
  "schema.description": "kaiyun com 官方正版授权综合平台，提供安全、稳定、流畅的一站式服务体验。",
};

export default translations;